import { today } from "owa-datetime";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";
import { mutatorAction } from "satcheljs";

import type { OwaDate } from "owa-datetime";

const store = createStore<{
    agendaOrPlacesFinder: "agenda" | "placesFinder";
    isInMapTab: boolean;
    currentDate: OwaDate;
    placesType: "Room" | "DeskPool";
    selectedCollaborators: string[];
    hasFloorPlan: boolean;
    selectedOrDefaultBuildingId: string;
}>("hybridspace-places-finder-store", {
    agendaOrPlacesFinder: "agenda",
    isInMapTab: false,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function today called at module scope is not allowed. This may cause unwanted side effects. */
    currentDate: today(),
    placesType: "Room",
    selectedCollaborators: [],
    hasFloorPlan: false,
    selectedOrDefaultBuildingId: "none",
});

const dest = createAccessors("hybridspace-places-finder-store", store);
export const getAgendaOrPlacesFinder: () => "agenda" | "placesFinder" = dest.getAgendaOrPlacesFinder;
export const setAgendaOrPlacesFinder: (newValue: "agenda" | "placesFinder") => void = dest.setAgendaOrPlacesFinder;
export const getIsInMapTab: () => boolean = dest.getIsInMapTab;
export const setIsInMapTab: (newValue: boolean) => void = dest.setIsInMapTab;
export const getCurrentDate: () => OwaDate = dest.getCurrentDate;
export const setCurrentDate: (newValue: OwaDate) => void = dest.setCurrentDate;
export const getPlacesType: () => "Room" | "DeskPool" = dest.getPlacesType;
export const setPlacesType: (newValue: "Room" | "DeskPool") => void = dest.setPlacesType;
export const setSelectedCollaborators: (newValue: string[]) => void = dest.setSelectedCollaborators;
export const getSelectedCollaborators: () => string[] = dest.getSelectedCollaborators;
export const setHasFloorPlan: (newValue: boolean) => void = dest.setHasFloorPlan;
export const getHasFloorPlan: () => boolean = dest.getHasFloorPlan;
export const getSelectedOrDefaultBuildingId: () => string = dest.getSelectedOrDefaultBuildingId;
export const setSelectedOrDefaultBuildingId: (newValue: string) => void = dest.setSelectedOrDefaultBuildingId;

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const initializePlacesFinderStore: () => void = mutatorAction("initializePlacesFinderStore", (): void => {
    const createdStore = store();
    createdStore.currentDate = today();
});
